import React from "react";
import DartLeagueApp from "../components/DartLeague/DartLeagueApp";

const DartLeaguePage = () => {
  return <DartLeagueApp />;
};

export default DartLeaguePage;
